export default __webpack_public_path__ + "static/media/social.3ff7f2d1.png";